import { useApplicationModals } from "app/common/hooks";
import { useCreateForm } from "app/integration/common/hooks";
import * as Yup from "yup";
import api from "app/integration/api";
import { ModalMolecule } from "app/components/molecules/modal";
import { Formik } from "formik";
import { Button, OutlineButton } from "app/components/atoms/button";
import AppModals from ".";
import { useState } from "react";
import * as XLSX from 'xlsx';
import { Badge } from "app/components/atoms/badge";
import { dateExcel } from "lib/str";

function ImportSalesOrderShopee({ onSuccess = () => { } }) {
  const { showStates, closeModal } = useApplicationModals();
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = () => {
    closeModal("salesOrder.importshopee");
    setFailedData([]); setProcessedData([])
  };
  const handleSuccess = () => {
    onSuccess();
  };

  var isError = false;

  const { openModal, setPayloads } = useApplicationModals();
  const [data, setData] = useState([]);
  const [processedData, setProcessedData] = useState([]);
  const [failedData, setFailedData] = useState([]);

  const { initialValues, validationSchema, onSubmit } = useCreateForm({
    initialValues: {
      id: null,
      fileImport: "",
      data: {},
    },
    validationSchema: Yup.object().shape({
      fileImport: Yup.mixed().required("File harus diisi")
        .test('fileFormat', 'Only Excel files are allowed', value => {
          if (value) {
            const supportedFormats = ['xlsx', 'xls', 'csv'];
            return supportedFormats.includes(value.name.split('.').pop());
          }
          return true;
        })
        .test('fileSize', 'File size must be less than 3MB', value => {
          if (value) {
            return value.size <= 3145728;
          }
          return true;
        }),
    }),
    onSubmit: async (values) => {
      try {
        setIsLoading(true);
        setFailedData([]); setProcessedData([]);
        // Assuming `data` is the sheet data
        for (let i = 0; i < data.length; i++) {
          const temp = { ...data[i], index: i + 1 };
          try {
            const importData = await api.salesOrder.import(
              dateExcel(temp.time_order_created),
              Number(temp.shipping_cost) || 0,
              1,
              temp.order_id,
              "SHOPEE",
              Number(temp.payment_amount) || 0,
              temp.note_buyer,
              0,
              temp.customer_name,
              `${temp.customer_address} ${temp.customer_kota} ${temp.customer_provinsi}`,
              dateExcel(temp.time_order_paid),
              dateExcel(temp.time_order_created),
              [
                {
                  product_name: temp.product_name,
                  unit_price: Number(temp.start_price) || 0,
                  qty: Number(temp.qty_product_order) || 0,
                  discount_reseller: Number(temp.discount_seller) || 0,
                }
              ]
            );
            if (importData?.status === "success") {
              setProcessedData(prevData => [...prevData, temp]); // Add the processed row to the state
            } else {
              throw new Error(`Import failed for row ${i + 1}`);
            }
          } catch (error) {
            temp.errorMessage = error?.response?.data?.message;
            setFailedData(prevFailed => [...prevFailed, temp]);
          }
        }
        const responseOrderStatus = await api.salesOrder.updateDeliveryOrderStatus();
        if (responseOrderStatus?.status !== "success") {
          throw new Error(`Failed to update delivery order status`);
        }
        isError = false;
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        setPayloads("errorMessage.view", {
          title: "Import Whatsapp Error",
          message:
            error?.response.status === 400
              ? "Gagal tambah sales order."
              : error?.response?.data?.message,
        });
        isError = true;
        openModal("errorMessage.view");
      }
    },
    onSuccess: () => {
      if (!isError) {
        handleSuccess();
      }
    },
  });

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onload = (event) => {
      const dataExcel = new Uint8Array(event.target.result);
      const workbook = XLSX.read(dataExcel, { type: 'array' });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const sheetData = XLSX.utils.sheet_to_json(sheet);

      let tempData = [];

      for (let index = 0; index < sheetData.length; index++) {
        tempData.push({
          order_id: sheetData[index]["No. Pesanan"],
          status_order: sheetData[index]["Status Pesanan"],
          status_retur: sheetData[index]["Status Pembatalan/ Pengembalian"],
          no_resi: sheetData[index]["No. Resi"],
          delivery_option: sheetData[index]["Opsi Pengiriman"],
          is_pickup: sheetData[index]["Antar ke counter/ pick-up"],
          limit_delivery_date: sheetData[index]["Pesanan Harus Dikirimkan Sebelum (Menghindari keterlambatan)"],
          schedule_delivery: sheetData[index]["Waktu Pengiriman Diatur"],
          time_order_created: sheetData[index]["Waktu Pesanan Dibuat"],
          time_order_paid: sheetData[index]["Waktu Pembayaran Dilakukan"],
          payment_method: sheetData[index]["Metode Pembayaran"],
          sku_induk: sheetData[index]["SKU Induk"],
          product_name: sheetData[index]["Nama Produk"],
          no_referensi_sku: sheetData[index]["No. Referensi SKU"],
          variant: sheetData[index]["Nama Variasi"],
          start_price: sheetData[index]["Harga Awal"],
          after_discount_price: sheetData[index]["Harga Setelah Diskon"],
          qty: sheetData[index]["Jumlah"],
          returned_qty: sheetData[index]["Returned quantity"],
          total_price_product: sheetData[index]["Total harga produk"],
          total_discount_produk: sheetData[index]["Total Diskon"],
          discount_seller: sheetData[index]["Diskon Dari Penjual"],
          discount_shopee: sheetData[index]["Diskon Dari Shopee"],
          weight: sheetData[index]["Berat Produk"],
          qty_product_order: sheetData[index]["Jumlah Produk di Pesan"],
          total_weight_order: sheetData[index]["Total Berat"],
          voucher_seller: sheetData[index]["Voucher Ditanggung Penjual"],
          cashback_coin: sheetData[index]["Cashback Koin"],
          voucher_shopee: sheetData[index]["Voucher Ditanggung Shopee"],
          discount_packet: sheetData[index]["Paket Diskon"],
          discount_packet_shopee: sheetData[index]["Paket Diskon (Diskon dari Shopee)"],
          discount_packet_seller: sheetData[index]["Paket Diskon (Diskon dari Penjual)"],
          discount_coin_shopee: sheetData[index]["Potongan Koin Shopee"],
          discount_credit_card: sheetData[index]["Diskon Kartu Kredit"],
          shipping_cost: sheetData[index]["Ongkos Kirim Dibayar oleh Pembeli"],
          estimation_discount_shipping_cost: sheetData[index]["Estimasi Potongan Biaya Pengiriman"],
          shipping_cost_retur: sheetData[index]["Ongkos Kirim Pengembalian Barang"],
          payment_amount: sheetData[index]["Total Pembayaran"],
          prediction_shipping_cost: sheetData[index]["Perkiraan Ongkos Kirim"],
          note_buyer: sheetData[index]["Catatan dari Pembeli"],
          note: sheetData[index]["Catatan"],
          customer_name: sheetData[index]["Username (Pembeli)"],
          recipient_name: sheetData[index]["Nama Penerima"],
          customer_telp: sheetData[index]["No. Telepon"],
          customer_address: sheetData[index]["Alamat Pengiriman"],
          customer_kota: sheetData[index]["Kota/Kabupaten"],
          customer_provinsi: sheetData[index]["Provinsi"],
          end_order_time: sheetData[index]["Waktu Pesanan Selesai"],
        });
      }

      setData(tempData);
    };

    if (file) {
      reader.readAsArrayBuffer(file); // Use readAsArrayBuffer
    }
  }

  const downloadFailedData = () => {
    const tes = XLSX.utils.json_to_sheet(failedData);
    const ws = [
      ["No. Pesanan", "Status Pesanan", "Status Pembatalan/Pengembalian", "No. Resi", "Opsi Pengiriman", "Antar ke counter/ pick-up", "Pesanan Harus Dikirimkan Sebelum (Menghindari keterlambatan)", "Waktu Pengiriman Diatur", "Waktu Pesanan Dibuat", "Waktu Pembayaran Dilakukan", "Metode Pembayaran", "SKU Induk", "Nama Produk", "No. Referensi SKU", "Nama Variasi", "Harga Awal", "Harga Setelah Diskon", "Jumlah", "Returned quantity", "Total harga produk", "Total Diskon", "Diskon Dari Penjual", "Diskon Dari Shopee", "Berat Produk", "Jumlah Produk di Pesan", "Total Berat", "Voucher Ditanggung Penjual", "Cashback Koin", "Voucher Ditanggung Shopee", "Paket Diskon", "Paket Diskon (Diskon dari Shopee)", "Paket Diskon (Diskon dari Penjual)", "Potongan Koin Shopee", "Diskon Kartu Kredit", "Ongkos Kirim Dibayar oleh Pembeli", "Estimasi Potongan Biaya Pengiriman", "Ongkos Kirim Pengembalian Barang", "Total Pembayaran", "Perkiraan Ongkos Kirim", "Catatan dari Pembeli", "Catatan", "Username (Pembeli)", "Nama Penerima", "No. Telepon", "Alamat Pengiriman", "Kota/Kabupaten", "Provinsi", "Waktu Pesanan Selesai"]
    ];

    for (let index = 0; index < failedData.length; index++) {
      ws.push([
        failedData[index].order_id,
        failedData[index].status_order,
        failedData[index].status_retur,
        failedData[index].no_resi,
        failedData[index].delivery_option,
        failedData[index].is_pickup,
        failedData[index].limit_delivery_date,
        failedData[index].schedule_delivery,
        failedData[index].time_order_created,
        failedData[index].time_order_paid,
        failedData[index].payment_method,
        failedData[index].sku_induk,
        failedData[index].product_name,
        failedData[index].no_referensi_sku,
        failedData[index].variant,
        failedData[index].start_price,
        failedData[index].after_discount_price,
        failedData[index].qty,
        failedData[index].returned_qty,
        failedData[index].total_price_product,
        failedData[index].total_discount_produk,
        failedData[index].discount_seller,
        failedData[index].discount_shopee,
        failedData[index].weight,
        failedData[index].qty_product_order,
        failedData[index].total_weight_order,
        failedData[index].voucher_seller,
        failedData[index].voucher_shopee,
        failedData[index].cashback_coin,
        failedData[index].discount_packet,
        failedData[index].discount_packet_shopee,
        failedData[index].special_discount,
        failedData[index].discount_packet_seller,
        failedData[index].discount_coin_shopee,
        failedData[index].discount_credit_card,
        failedData[index].shipping_cost,
        failedData[index].estimation_discount_shipping_cost,
        failedData[index].shipping_cost_retur,
        failedData[index].payment_amount,
        failedData[index].prediction_shipping_cost,
        failedData[index].note_buyer,
        failedData[index].note,
        failedData[index].customer_name,
        failedData[index].recipient_name,
        failedData[index].customer_telp,
        failedData[index].customer_address,
        failedData[index].customer_kota,
        failedData[index].customer_provinsi,
        failedData[index].end_order_time,
      ])
    }
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(ws), "Failed Data");
    XLSX.writeFile(wb, "failed_data.xlsx");
  };

  return (
    <ModalMolecule
      show={showStates["salesOrder.importshopee"]}
      title="Import Sales Order Shopee"
      onClose={handleClose}
    >
      {isLoading && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-200 bg-opacity-50 z-50 flex justify-center items-center">
          <div className="bg-white p-4 rounded-md">
            <p>Loading...</p>
          </div>
        </div>
      )}
      <AppModals
        items={["errorMessage.view"]}
        onSuccess={{
          "errorMessage.view": () => fetch(),
        }}
      />
      <Formik
        {...{ initialValues, validationSchema, onSubmit }}
        enableReinitialize={true}
      >
        {({
          values,
          errors,
          status,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => (
          <form className="space-y-2" onSubmit={handleSubmit}>
            <>
              <div>Import Sales Order</div>
              <input data-testid="modal-import-sales-order-shopee-fileimport-input"
                type="file"
                name="fileImport"
                onChange={(e) => {
                  handleFileUpload(e);
                  setFieldValue("fileImport", e.currentTarget.files[0]);
                  // Set the file name here if needed
                }}
              />
              <p className="text-danger-600">
                {errors.fileImport && touched.fileImport && errors.fileImport}
              </p>
            </>
            <div>
              {
                processedData.length > 0 ? (
                  <div>
                    <h3>Processed Data:</h3>
                    <ul>
                      {processedData.map((row, index) => (
                        <li key={index}>Baris ke-{row.index} <Badge color={"green"}>{row.order_id}</Badge> <Badge color={"green"}>Success</Badge></li>
                      ))}
                    </ul>
                  </div>
                ) : null
              }
              {
                failedData.length > 0 ? (
                  <div>
                    <h3>Failed Data:</h3>
                    <ul>
                      {failedData.map((row, index) => (
                        <li key={index}>Baris ke-{row.index} <Badge color={"red"}>{row.errorMessage}</Badge> <Badge color={"red"}>Failed</Badge>
                        </li>
                      ))}
                    </ul>
                  </div>
                ) : null
              }
            </div>
            {
              failedData.length > 0 ? (
                <OutlineButton testId="modal-import-sales-order-shopee-download-failed-data-button" type="button" onClick={downloadFailedData} className="btn btn-primary">
                  Download Failed Data
                </OutlineButton>
              ) : null
            }
            <div className="fixed bottom-2 left-0 sm:left-auto right-0 sm:right-4 sm:bottom-4 sm:w-auto z-40 flex justify-end border-t border-gray-100 bg-white sm:bg-transparent p-4 sm:p-0 dark:border-gray-700 dark:bg-gray-800 print:hidden sm:absolute sm:rounded-b-lg sm:border-0 ">
              <Button testId="modal-import-sales-order-shopee-import-button" type="submit">Import</Button>
            </div>
          </form>
        )}
      </Formik>
    </ModalMolecule>
  );
}
export default ImportSalesOrderShopee;
